import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=48a1172c&scoped=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
import style0 from "./Course.vue?vue&type=style&index=0&id=48a1172c&prod&lang=css"
import style1 from "./Course.vue?vue&type=style&index=1&id=48a1172c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1172c",
  null
  
)

export default component.exports